import { Link } from "react-router-dom";

interface LegalLinksProps {
  linkClassName?: string;
}

/** Terms of Service and Privacy Policy, for AppFooter and MobileLegalLinks. */
export function LegalLinks(props: LegalLinksProps): JSX.Element {
  const className = `text-ink-2 ${props.linkClassName ?? ""}`;

  return (
    <>
      <Link to="/terms" className={className}>
        Terms of Service
      </Link>
      <Link to="/privacy" className={className}>
        Privacy Policy
      </Link>
    </>
  );
}

export default LegalLinks;
